/**
 * Lättviktig head-hjälpare för adminsidor.
 *
 * Ligger i en egen modul (inte i AdminShell) eftersom `head`/`Route`-delen av varje
 * adminrutt inte kodsplittas – importeras den från AdminShell dras hela adminskalet
 * in i den delade startbundlen som alla besökare laddar.
 */
export function adminHead(pageTitle: string, pageDescription: string) {
  const full = `${pageTitle} | Swedish International School`;
  return {
    meta: [
      { title: full },
      { name: "description", content: pageDescription },
      { property: "og:title", content: full },
      { property: "og:description", content: pageDescription },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
      { name: "robots", content: "noindex" },
    ],
  };
}
